/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.route

object UserPath {
    const val ROOT = "user"

    /**
     * A post to this endpoint containing a [systems.frictionless.impulse.rest.model.Password] can change the password.
     */
    const val PASSWORD = "$ROOT/password"

    /**
     * A post to this endpoint containing an [systems.frictionless.impulse.rest.model.Email] can trigger a password reset.
     */
    const val FORGOT_PASSWORD = "$ROOT/password/forgot"

    object ChangePassword {
        const val FRAGMENT = "change_password"

        /**
         * Base64 encoded email. Must be decoded by client.
         */
        const val EMAIL = "email"

        /**
         * Token.  Should not be decoded by client, because it needs to be encoded for posting.
         */
        const val TOKEN = "token"
    }
}
